import { render, staticRenderFns } from "./CatalogDashboardTitle.vue?vue&type=template&id=234aad82&scoped=true"
import script from "./CatalogDashboardTitle.vue?vue&type=script&lang=js"
export * from "./CatalogDashboardTitle.vue?vue&type=script&lang=js"
import style0 from "./CatalogDashboardTitle.vue?vue&type=style&index=0&id=234aad82&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234aad82",
  null
  
)

export default component.exports